// return true if any form is shown as overlay on top of page
export function isAnyOverlayFormVisible() {
  const state = window.getState();

  return (
    state.modalReducer.showAddToCallWaitingAreaModal === true ||
    state.modalReducer.showForgetPasswordModal === true || // Sign in page - forget password
    state.modalReducer.showChangeUserProfileModal === true || // My Profile
    state.modalReducer.showViewWaitingAreaParticipantModal === true || // PiWA - <caller> - Participants - <name>
    state.modalReducer.showChangePasswordModal === true || // Change Password
    state.modalReducer.showCreateSmsNotification === true || // Create 'new caller' alerts
    state.modalReducer.showNotifyRoomParticipantModal === true || // Notify Room Participant
    state.modalReducer.showResetPasswordTokenModal === true || // Reset Password via email link
    state.modalReducer.showUpdateWaitingAreaModal === true || // show updating WA general info
    state.modalReducer.showViewWaitingAreaModal === true || // show view WA general Info
    state.modalReducer.showUpdateWaitingAreaOperatingHoursModal === true || // show update WA Operating Hours
    state.modalReducer.showViewWaitingAreaOperatingHoursModal === true || // show view WA Operating Hours
    state.modalReducer.showViewMeetingRoomParticipantModal === true || // show view Meeting room Participant Modal Reducers
    state.modalReducer.showUpdateWaitingAreaLocalAccessHoursModal === true || // show update local access hours
    state.modalReducer.showWaitingAreaLogoPauseImageModal === true || // show view update Logo Pause Image
    state.modalReducer.showViewWaitingAreaLocalAccessHoursModal === true || // show view local access hours
    state.modalReducer.showUpdateSmsNotification === true || // Create 'new caller' alerts
    state.modalReducer.showBeforeCallsModal === true || // show before calls modal
    state.modalReducer.showBeforeCallsImportantInfoModal === true || // show before calls (Important Info) modal
    state.modalReducer.showCallerEntryModal === true || // show view caller entry point
    state.modalReducer.showDuringCallsModal === true || // Create during calls modal
    state.modalReducer.showAfterCallsModal === true || // show after calls modal
    state.modalReducer.showSuspendWAModal === true || // Suspend WA
    state.modalReducer.showWaitingAreaAddUsersModal === true || // Add user to waiting area dialog
    state.modalReducer.showWaitingAreaSelfProvisionCreateModal === true || // Waiting Area Self provision for existing user
    state.modalReducer.showWaitingAreaWelcomeModal === true || //Welcome Waiting Area
    state.modalReducer.showSharedWAForOrgUnitModal === true || // Shared waiting area settings dialog
    state.modalReducer.showRemoveTagConfirmationModal === true || // Remove tag dialog
    state.modalReducer.showRemoveTagConfirmationModalInOU === true || // Remove tag dialog in OU
    state.modalReducer.showMyRolesModal === true || // showing my roleas
    state.modalReducer.showSupportContactModal === true || // SupportContactDialogue
    state.modalReducer.showCallHistoryModal === true || // Call activity dialog
    state.modalReducer.showDeleteWAModal === true || // Delete waiting area
    state.modalReducer.showDeleteOrganizationModal === true || // Delete organization
    state.modalReducer.showOtherUsersProfileModal === true || // View other user's profile
    state.modalReducer.showWaitingAreaSelfProvisionModal === true || // Invite self-provisioning
    state.modalReducer.showEditPortalSetting === true || //Edit portal settings
    state.modalReducer.showGCSettingsModal === true // show GC setting modal to update chat and fullName toggle
  );
}

// return true if any form (with input controls) is shown
export function isAnyInputFormVisible() {
  const state = window.getState();

  return (
    state.modalReducer.showForgetPasswordModal === true || // Sign in page - forget password
    state.modalReducer.showChangeUserProfileModal === true || // My Profile
    state.modalReducer.showNotifyRoomParticipantModal === true || // Notify Room Participant
    state.modalReducer.showChangePasswordModal === true || // Change Password
    state.modalReducer.showResetPasswordTokenModal === true || // Reset Password via email link
    state.modalReducer.showUpdateWaitingAreaModal === true || // show updating WA general info
    state.modalReducer.showUpdateWaitingAreaOperatingHoursModal === true || // show update WA Operating Hours
    state.modalReducer.showUpdateWaitingAreaLocalAccessHoursModal === true || // show update local access hours
    state.modalReducer.showUpdateSmsNotification === true || // Create 'new caller' alerts
    state.modalReducer.showBeforeCallsModal === true || // show before calls modal
    state.modalReducer.showBeforeCallsImportantInfoModal === true || // show before calls important info modal
    state.modalReducer.showDuringCallsModal === true || // Create during calls modal
    state.modalReducer.showCallerEntryModal === true || // show update caller entry point
    state.modalReducer.showAfterCallsModal === true || // show after calls modal
    state.modalReducer.showWaitingAreaLogoPauseImageModal === true || // show view update Logo Pause Image
    state.modalReducer.showManageRolesForUsersModal === true || // Manage user roles
    state.modalReducer.showManageRolesForOrgUsersModal === true || // Manage user roles
    state.modalReducer.showWaitingAreaAddUsersModal === true || // Add user to waiting area dialog
    state.modalReducer.showSetMinDurationsModal === true || // Set minimum duration for reports
    state.modalReducer.showWaitingAreaSelfProvisionCreateModal === true || // Waiting Area Self provision for existing user
    state.modalReducer.showSharedWAForOrgUnitModal === true || // Shared waiting area settings dialog
    state.modalReducer.showRemoveTagConfirmationModal === true || // Remove tag dialog
    state.modalReducer.showRemoveTagConfirmationModalInOU === true || // Remove tag dialog in OU
    state.modalReducer.showEditTagValueModal === true || // Edit tags dialog
    state.modalReducer.showAssignTagsModal === true || // Assign tags dialog
    state.modalReducer.showEditTagValueModalInOU === true || // Edit tags dialog in OU
    state.modalReducer.showAssignTagsModalInOU === true || // Assign tags dialog in OU
    state.modalReducer.showMyRolesModal === true || // showing my roleas
    state.modalReducer.showSupportContactModal === true || // SupportContactDialogue
    state.modalReducer.showMeetingRoomAddUsersModal === true || // Meeting Room Add users modal
    state.modalReducer.showMeetingRoomManageUsersRolesModal === true || // Meeting Room Manage users roles modal
    state.modalReducer.showOtherUsersRolesModal === true || // Manage other user's roles
    state.modalReducer.showCreateOUModal === true || //Create OU
    state.modalReducer.showWaitingAreaSelfProvisionModal === true || // Invite self-provisioning
    state.modalReducer.showEditPortalSetting === true || // Edit portal settings
    state.modalReducer.showShareByEmailModal === true || // Share by email in PIWA
    state.modalReducer.showShareByTextModal === true || // Share by text in PIWA
    state.modalReducer.showGCSettingsModal === true // show GC setting modal to update chat and fullName toggle
  );
}
